import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";

const Timer = ({ maxTime, children, style }) => {
  const [timer, setTimer] = useState(maxTime);

  useEffect(() => {
    setTimer(maxTime);

    // Interval to update the timer every second
    const intervalId = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    // Cleanup function to clear the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, [maxTime]);

  // Render prop: let the caller decide how the remaining seconds are displayed
  if (typeof children === 'function') {
    return children(timer);
  }

  return (
    <div style={{ fontSize: 14, color: '#8c8c8c', ...style }}>
      Timer: {timer} seconds
    </div>
  );
};

Timer.propTypes = {
    maxTime: PropTypes.number,
    children: PropTypes.func,
    style: PropTypes.object
};

export default Timer;
